export default __webpack_public_path__ + "img/icon-welcome@2x.1b55f06d62375ff047ce83674a358182.jpg";